import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import productOrder from './views/product-order'

export default [
  {
    path: RoutePathConstants.PRODUCT_ORDER,
    name: 'productOrder',
    component: productOrder
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-order/routers.js